<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Cactivity :navsub="navsub" :options="c_myoption" v-if="isload" :grouplist="grouplist"></Cactivity>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'myactivity',
        mixins: [mixinmember],
        components: {
            Cactivity: () => import('@/components/Cactivity')
        },
        data() {
            return {
                curnavkv: 23
            };
        },
        computed: {
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'noteng': 1, 'issch': 0
                };
                switch (this.navsub) {
                    case 0:
                        _options.showcourse = 0;
                        _options.haskw = false;
                        break;
                    case 1:
                        _options.showcourse = 2;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 3;
                _myoption.isdone = this.navsub;
                return _myoption;
            }
        }
    }
</script>
